/*
 * Module for performing file uploads.
*/

rs.module("controls/file/fileupload",

    [
        "ui/framework/client-templates",
        "common/visibility",
        "controls/components/event-banner"
    ],

    function (clientTemplates, visibility, eventBanner) {

        //
        // Initialize
        //
        function initialize(uploadSettings, jsSelectors, cssClasses, templateKeys, uploadUrl) {

            var onFileUploadCompleteCallback;
            var onFileUploadStartedCallback;

            var control = $.js(jsSelectors.control);
            var chosenFiles = uploadSettings.stagedFiles ? uploadSettings.stagedFiles : [];
            var fileList = control.js(jsSelectors.files);
            var htmlUploadControl = $.js(jsSelectors.fileInput);

            // setup a timer to run every minute to keep the upload session alive by performing a GET on the upload url.
            setInterval(function () {
                $.get(uploadUrl)
                    .fail(function (xhr)
                    {
                        // Expired/missing upload sessions get reported as Gone (410)
                        if (xhr.status === 410) {

                            // we'll use the same generic message we use for general pagesecuritycontext request failures
                            eventBanner.addErrorMessages("This page has become dormant and must be reloaded before performing the requested action.");
                        }
                    });
            }, uploadSettings.keepAlivePeriodMinutes * 60 * 1000);

            _setupExistingFiles();
            _normalizeFileTypes();
            _updateControlStatus();
            _updateUploadLimits();

            // when the fileList is clicked, click the hidden upload input so the file dialog opens
            // for manual file selection.
            fileList.on('click', function() {
                if (_allowMoreFiles(1)) {
                    htmlUploadControl.click();
                }
            });

            // Stop the click event of the hidden upload control from bubbling up, causing a stack overflow.
            htmlUploadControl.on('click', function(e) {
                e.stopPropagation();
            });

            // Handle the manual selection of files by starting their upload.
            htmlUploadControl.on('change', function () {
                for (var i = 0; i < this.files.length; i++) {
                    _beginUpload(this.files[i]);
                }

                // clear the html control, we don't need it now
                htmlUploadControl.val(null);
            });

            // Listen for dragover event so we can signal fileList is a drop target.
            fileList.on('dragover', function(e) {
                e.stopPropagation();
                e.preventDefault();

                if (_allowMoreFiles(e.originalEvent.dataTransfer.items.length)) {
                    // change the control to highlight that it's a drop target
                    fileList.addClass(cssClasses.hover);

                    e.originalEvent.dataTransfer.dropEffect = 'copy';
                }
                else {
                    e.originalEvent.dataTransfer.dropEffect = 'none';
                }
            });

            // Listen for the dragleave event to stop highlighting the drop area.
            fileList.on('dragleave', function() {
                fileList.removeClass(cssClasses.hover);
            });

            // Listen for the drop event to trigger uploading/staging of the dropped files.
            fileList.on('drop', function(e) {
                e.stopPropagation();
                e.preventDefault();

                var files = e.originalEvent.dataTransfer.files;

                // Begin upload of each selected file.
                for (var i = 0; i < files.length; i++) {
                    _beginUpload(files[i]);
                }

                fileList.removeClass(cssClasses.hover);
            });

            // Attach to the form's formdata event so uploaded files can be submitted with the form.
            var form = fileList.closest("form");
            if (form.exists()) {

                // Handle formdata by adding succesfully uploaded ("staged") files to the posted form values.
                form.on("formdata", function (e) {

                    // if the grid is no longer part of the page, do not add form values
                    if (!document.body.contains(control[0])) {

                        // detach this handler instance so it doesn't happen again
                        form.off('formdata', e.data.handler);
                        return;
                    }

                    // Get the form data from the event object.
                    let formData = e.originalEvent.formData;
                    let i = 0;

                    // Add files which have succesfully uploaded.
                    chosenFiles.forEach(file => {
                        if (file.uploaded) {
                            var name = uploadSettings.inputName;
                            if (uploadSettings.allowMultiple) {
                                name += `[${i++}]`;
                            }

                            formData.append(name, file.encoded);
                        }
                    });
                });
            }

            // Returns whether the control can accept more files given its configuration and present state.
            function _allowMoreFiles(count) {
                // more files can always be added in multi-file uploads 
                if (uploadSettings.allowMultiple) {
                    return true;
                }

                var nonFailed = chosenFiles.filter(file => !file.failed).length;
                if (nonFailed + count > 1) {
                    return false;
                }
                else {
                    return true;
                }
            }

            // Converts a byte count to a useful size description
            function _bytesToSize(bytes) {
                var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
                if (bytes == 0) return '0 Byte';
                var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
            }

            // Processes uploadSettings.fileTypes so they are all lowercase and exclude the "."
            function _normalizeFileTypes() {
                for (var i = 0; i < uploadSettings.fileTypes.length; i++) {
                    var value = uploadSettings.fileTypes[i];

                    value = value.replace('.', '').toLowerCase();

                    uploadSettings.fileTypes[i] = value;
                }
            }

            // Updates the upload limits text on the control for the user
            function _updateUploadLimits() {
                var limitText = uploadSettings.fileTypes.sort().join(', ');

                limitText += ` files up to ${_bytesToSize(uploadSettings.maximumSize)}`;

                control.js(jsSelectors.uploadLimits).html(limitText);
            }

            // Updates the control's status text and other general UI based on settings and current state.
            function _updateControlStatus() {
                var readyForUpload = chosenFiles.filter(file => file.uploaded).length;
                var statusText = '';
                if (uploadSettings.allowMultiple) {
                    fileList.addClass(cssClasses.pointer);

                    if (readyForUpload == 0) {
                        statusText = 'Add files to submit';

                    }
                    else if (readyForUpload == 1) {
                        statusText = '1 file ready to submit';
                    }
                    else {
                        statusText = `${readyForUpload} files ready to submit`;
                    }
                }
                else {
                    if (readyForUpload == 0) {
                        statusText = 'Add a file to submit';
                    }
                    else if (readyForUpload == 1) {
                        statusText = 'Selected file ready to submit'
                    }

                    if (_allowMoreFiles(1)) {
                        // add hover style
                        fileList.addClass(cssClasses.pointer);
                    }
                    else {
                        // remove hover style
                        fileList.removeClass(cssClasses.pointer);
                    }
                }

                control.js(jsSelectors.controlStatus).html(statusText);
            }

            // Updates the display of the instructions
            function _updateInstructions(action) {
                if (chosenFiles.length == 0 && action.addingFile) {
                    fileList.removeClass(cssClasses.empty);
                    visibility.hide(control.js(jsSelectors.instructions));
                }
                else if (chosenFiles.length == 0 && action.removedFile) {
                    fileList.addClass(cssClasses.empty);
                    visibility.show(control.js(jsSelectors.instructions));
                }
            }

            // Sets text of a file UI widget, optionally indicating an error.
            function _setFileStatus(file, status, error) {
                file.html.js(jsSelectors.fileText).html(file.originalName + ` - ${status}`);

                if (error) {
                    file.html.addClass(cssClasses.uploadError);
                    file.failed = true;

                    _updateControlStatus();
                }
            }

            // remove a chosenFiles file
            function _removeChosenFile(file) {
                // remove the UI element
                file.html.remove();

                // remove it from the managed list of files
                chosenFiles = chosenFiles.filter(chosen => chosen != file);

                // update status text
                _updateControlStatus();
            }

            // Ensures that each file passes necessary requirements to allow uploading.
            function _verifySizeAndType(file, droppedFile) {

                // Make sure it's less than the maximum the server is going to allow
                if (file.size > uploadSettings.maximumSize) {
                    _setFileStatus(droppedFile, 'file too large', true)
                    return false;
                }

                // Make sure it's an allowed file extension.
                var typeAllowed = true;
                var parts = file.name.split('.');
                if (parts.length == 0) {
                    typeAllowed = false;
                }
                else {
                    typeAllowed = uploadSettings.fileTypes.includes(parts.pop().toLowerCase())
                }

                if (!typeAllowed) {
                    _setFileStatus(droppedFile, 'file type not allowed', true)
                }

                return typeAllowed;
            }

            // Re-links the chosenFiles collection with the UI widgets rendered server side on load.
            function _setupExistingFiles() {
                chosenFiles.forEach(file => {
                    fileList.js(jsSelectors.file, { multiple: true }).each(function () {

                        // Find the file widget associated with this file, by its encoded value.
                        if ($(this).data('encoded') == file.encoded) {

                            // Complete the same setup that would have been done if the user had selected the file interactively.
                            file.html = $(this);
                            _attachHandlersToFileWidget(file);
                        }
                    });
                });
            }

            // Attach necessary event handlers to the file ui/widget.
            function _attachHandlersToFileWidget(file) {

                file.html
                    // clicking on the file does nothing
                    .on('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    })
                    // Clicking on the remove button removes the widget from the file listing.
                    .js(jsSelectors.removeFile).on('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();

                        _removeChosenFile(file);
                        _updateInstructions({ removedFile: true });
                    });
            }

            // Starts the file upload process for a file.
            function _beginUpload(file) {

                // if callback was provided, execute file upload started callback
                if (onFileUploadStartedCallback) {
                    onFileUploadStartedCallback.call();
                }

                var formData = new FormData();
                formData.append('file', file);

                // Show or hide the instructional message based.
                _updateInstructions({ addingFile: true });

                // The user can drop a file ontop of a failed upload and replace it, so remove an existing file.
                if (!uploadSettings.allowMultiple) {
                    if (chosenFiles.length > 0) {
                        _removeChosenFile(chosenFiles.pop());
                    }
                }

                var droppedFile = {
                    encoded: null,
                    uploaded: false,
                    failed: false,
                    originalName: file.name,
                    html: $(clientTemplates.render(templateKeys.file, { Encoded: '', NameAndStatus: `${file.name} - uploading` }))
                        .appendTo(fileList)
                };

                // Setup event handlers on the file UI widget.
                _attachHandlersToFileWidget(droppedFile);

                // keep track of this file
                chosenFiles.push(droppedFile);

                // Do what we can to catch file size and extension errors upfront.
                if (!_verifySizeAndType(file, droppedFile)) {
                    droppedFile.failed = true;

                    // if callback was provided, execute file upload complete callback, sending false to indicacte the upload was not successful, and including the error text
                    if (onFileUploadCompleteCallback) {
                        onFileUploadCompleteCallback.call(null, false, droppedFile.html.js(jsSelectors.fileText).text());
                    }

                    return;
                }

                // POST the file
                $.post({
                    xhr: function () {
                        // Custom XHR factory so we can hook into upload progress events.
                        let xhr = new window.XMLHttpRequest();
                        let activeFile = droppedFile;

                        // Setup progress handlers for displaying upload percentages.
                        xhr.upload.onprogress = function (e) {
                            if (e.lengthComputable) {
                                let percent = e.loaded * 100.0 / e.total;

                                if (percent < 100) {
                                    percent = $.format.number(percent, "0");

                                    _setFileStatus(activeFile, `uploading (${percent}%)`);
                                }
                                else {
                                    _setFileStatus(activeFile, `processing`);
                                }
                            }
                        };

                        return xhr;
                    },
                    url: uploadUrl,
                    data: formData,
                    cache: false,
                    processData: false,
                    contentType: false,
                    async: true,
                    context: { droppedFile },
                }).done(function (result, status, xhr) {
                    var uploadedFile = xhr.settings.context.droppedFile;
                    if (result.success) {

                        var fileInfo = result.stagedFile.split(';');
                        if (fileInfo.length > 0) {

                            uploadedFile.uploaded = true;
                            uploadedFile.encoded = result.stagedFile;
                            uploadedFile.html
                                .data("encoded", uploadedFile.Encoded)
                                .js(jsSelectors.fileText).html(uploadedFile.originalName);

                            _updateControlStatus();
                        }
                    }
                    else {
                        _setFileStatus(uploadedFile, `failed (${result.error.toLowerCase()})`, true);
                    }

                    // if callback was provided, execute file upload complete callback, sending a bool indicating if it was successful 
                    if (onFileUploadCompleteCallback) {
                        onFileUploadCompleteCallback.call(null, result.success, result.error);
                    }

                }).fail(function (xhr) {
                    var uploadedFile = xhr.settings.context.droppedFile;

                    if (xhr.status == 413) {
                        _setFileStatus(uploadedFile, 'file too large', true);
                    }
                    else {
                        _setFileStatus(uploadedFile, `failed (err. ${xhr.status})`, true);
                    }

                    // if callback was provided, execute file upload complete callback, sending false to indicate upload was not successful, and including the error text
                    if (onFileUploadCompleteCallback) {
                        onFileUploadCompleteCallback.call(null, false, uploadedFile.html.js(jsSelectors.fileText).text());
                    }
                });
            }

            //
            // API function to allow consumers to provide a callback to execute when a file upload has started
            //
            function onFileUploadStarted(onFileUploadStarted) {
                onFileUploadStartedCallback = onFileUploadStarted;
            }

            //
            // API function to allow consumers to provide a callback to execute when a file upload as completed
            //
            function onFileUploadComplete(onFileUploadComplete) {
                onFileUploadCompleteCallback = onFileUploadComplete;
            }

            // create the instance API and return it
            var instanceApi = {

                // Clears uploaded files from the control
                clear: function () {

                    // Remove file widgets
                    chosenFiles.forEach(function (file) {
                        file.html.remove();
                    })

                    // clear out the files array
                    chosenFiles = [];

                    // update the UI
                    _updateControlStatus();
                    _updateInstructions({ removedFile: true });
                },
                onFileUploadStarted,
                onFileUploadComplete,
                fileUploadControl: control
            };

            return instanceApi;
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);